<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col>
        <v-card>
          <v-card-title primary-title>
            <h1>Todo</h1>
          </v-card-title>
          <v-card-text>
            <p>Please come back later...</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
